import { HTMLAttributes } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

export interface ViewProps extends HTMLAttributes<HTMLDivElement> {
  flex?: number
  flexBasis?: number
  direction?: 'row' | 'column'
  justify?: 'baseline' | 'center' | 'end' | 'first baseline' | 'flex-end' | 'flex-start' | 'last baseline' | 'left' | 'right' | 'safe' | 'space-around' | 'space-between'
  align?: 'baseline' | 'center' | 'flex-end' | 'flex-start' | 'stretch' | 'inherit' | 'initial' | 'unset'
  spacing?: number
  cursor?: 'default' | 'pointer'
  w?: number | string
  h?: number | string
  bgColor?: string
  block?: boolean
  children?: React.ReactNode
}

export const View: React.FC<ViewProps> = ({ children, ...props }) => {
  return <StyledView {...props}>{children}</StyledView>
}

export default View

View.propTypes = {
  children: PropTypes.any,
}

View.defaultProps = {
  flex: 1,
  direction: 'row',
  justify: 'flex-start',
  align: 'flex-start',
  cursor: 'default',
  spacing: 0,
  bgColor: 'transparent',
  block: false,
}

const StyledView = styled.div<ViewProps>`
  position: relative;
  display: flex !important;

  flex-direction: ${(p) => p.direction} !important;
  justify-content: ${(p) => p.justify} !important;
  align-items: ${(p) => p.align} !important;
  gap: ${(p) => p.spacing}px !important;
  cursor: ${(p) => p.cursor} !important;
  background-color: ${(p) => p.bgColor} !important;
  background-color: transparent;

  ${(p) => p.flex && p.flex > 0 && `flex: ${p.flex} !important`};
  ${(p) => p.w && `max-width: ${p.w}px !important`};
  ${(p) => p.flexBasis && `flex-basis: ${p.flexBasis}px !important`};
  ${(p) => p.block && 'width: 100% !important'};
`
